import axios from 'axios'
import { EXCLUIR_MAPA_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirMapaVeiculo (cod) {
  const url = `${URL}/mapas-veiculos/${cod}/excluir`;
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_MAPA_VEICULO,
        payload: response
      })
  );
}
